import { bodyTextRadius } from './BodyTextStore';

export const updateBodyTextRadius = (value) => bodyTextRadius.update((oldValue) => value);
